<template>
  <div>
    <span
      class="live_chatting_username_container__m1-i5 live_chatting_username_is_message__jvTvP"
      style="margin-right: 4px"
    >
      <span class="live_chatting_username_wrapper__iJpJB">
        <span class="live_chatting_username_icon__6Dj7b">
          <span v-if="data.isFan" class="badge_container__a64XB">
            <img src="https://ssl.pstatic.net/static/nng/glive/icon/fan.png" alt="입덕 완료" width="18" height="18" />
          </span>
        </span>
      </span>
      <span class="live_chatting_username_nickname__dDbbj" :style="{ color: stringToColor(data.name) }">
        <span class=""
          ><span class="name_text__yQG50">{{ data.name }}</span></span
        >
      </span>
    </span>
    <span class="live_chatting_message_text__DyleH">
      <span v-html="data.modifiedMessage"></span>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      // required: true,
      default: () => ({
        isFan: true,
        name: "???",
        message: "???",
      }),
    },
  },
  methods: {
    stringToColor(str) {
      // Hash function for strings
      let hash = 0;
      for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }

      // Convert hash into an RGB color
      let color = "rgb(";
      for (let i = 0; i < 3; i++) {
        let value = (hash >> (i * 8)) & 0xff;
        color += value + ",";
      }
      return color.slice(0, -1) + ")";
    },
  },
};
</script>

<style scoped>
/* 팬 하트 뱃지 + 닉네임/메시지 세로 정렬 (기본 baseline → 가운데로 통일) */
.live_chatting_username_container__m1-i5,
.live_chatting_username_nickname__dDbbj,
.live_chatting_message_text__DyleH {
  vertical-align: middle;
}
.live_chatting_username_icon__6Dj7b,
.badge_container__a64XB {
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
}
.badge_container__a64XB img {
  display: block;
}

>>> .mark-1 {
  background-color: rgb(96, 23, 23);
  height: 100%;
  width: 100%;
  box-sizing: content-box;
}

>>> .mark-2 {
  background-color: rgb(5, 5, 187);
  height: 100%;
  width: 100%;
  box-sizing: content-box;
}
</style>
